import { render, staticRenderFns } from "./JudgesList.vue?vue&type=template&id=88ec80aa&scoped=true"
import script from "./JudgesList.vue?vue&type=script&lang=js"
export * from "./JudgesList.vue?vue&type=script&lang=js"
import style0 from "./JudgesList.vue?vue&type=style&index=0&id=88ec80aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ec80aa",
  null
  
)

export default component.exports